import { takeEvery, put } from "redux-saga/effects";
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import {store} from "../../store";
export default function* watcherDeleteProduct() {
    yield takeEvery("DELETE_PRODUCT", workerSaga);
}

function* workerSaga(action) {
    try {
        yield put({ type: "DISPLAY_LOADER" });
        let payload = {};
        var url = 'api/Admin/delete-product?id=' + action.payload;
        yield request("post", action.payload, url).then(response => {
            payload = response;
        });
        toast.success(payload)
        var formatUrl = 'api/Admin/get-products?companyId=' + store.getState().persistReducer.companyId
        yield request("get", action.payload, formatUrl).then(response => {
            payload = response;
        });
        yield put({ type: "PRODUCT_LIST", payload: payload })
         formatUrl = 'api/Admin/get-categories-dropdown/'+store.getState().persistReducer.companyId
        yield request("get", action.payload, formatUrl).then(response => {
            payload = response;
        });
        yield put({ type: "PRODUCT_CATEGORY_DROPDOWN_LIST", payload: payload })
        yield request(
            "get",
            action.payload,
            "/api/Admin/get-product-count?companyId=" + store.getState().persistReducer.companyId
          ).then((response) => {
            payload = response;
          });
          var products = payload.products;
          yield put({ type: "SET_PRODUCTS", payload: products });
          yield put({ type: "PERSIST_PRODUCTS", payload: products });
        yield put({ type: "DISPLAY_LOADER" });
    } catch (e) {
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        yield put({ type: "DISPLAY_LOADER" });
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
